export const DataMutationMyBag_PromoCodeApply_QueryKey = {
  mybagPromoCodeApply: (): string => {
    const queryKey = "data-mutation-mybag-promo-code-apply";
    return queryKey;
  },
};
